export default "__VITE_ASSET__C2QOo6gG__"